import styled from "styled-components";

export const StyledLabel = styled.div`
  font-weight: bold;
  font-size: 0.9rem;
`;
